// Small reusable form bits used across InputForms.

export function TextField({
  label,
  value,
  onChange,
  type = "text",
  required = false,
  readOnly = false,
  placeholder,
  testId,
}) {
  return (
    <label className="block">
      <span className="mb-1.5 block text-[0.78rem] font-semibold uppercase tracking-[0.16em] text-ink-700">
        {label} {required && <span className="text-red-500">*</span>}
      </span>
      <input
        data-testid={testId}
        className="field-input"
        inputMode={type === "number" ? "decimal" : undefined}
        type={type}
        value={value === 0 || value ? value : ""}
        placeholder={placeholder}
        readOnly={readOnly}
        disabled={readOnly}
        onChange={(event) => onChange(event.target.value)}
      />
    </label>
  );
}

export function SelectField({ label, value, onChange, options, required = false, testId }) {
  return (
    <label className="block">
      <span className="mb-1.5 block text-[0.78rem] font-semibold uppercase tracking-[0.16em] text-ink-700">
        {label} {required && <span className="text-red-500">*</span>}
      </span>
      <select
        data-testid={testId}
        className="field-input"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>
    </label>
  );
}

export function SectionTitle({ step, title, note }) {
  return (
    <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <p className="text-[0.7rem] font-semibold uppercase tracking-[0.28em] text-clay">{step}</p>
        <h2 className="mt-2 font-heading text-2xl font-semibold tracking-tight text-ink-900 sm:text-3xl">
          {title}
        </h2>
      </div>
      {note && <p className="max-w-2xl text-sm leading-relaxed text-ink-700">{note}</p>}
    </div>
  );
}
